var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _vm._m(0),
      _vm.modifyOrder && _vm.afterSale !== "afterSale"
        ? _c("div", { staticClass: "contentDetails" }, [
            _c(
              "div",
              { staticClass: "box" },
              [
                _c("Steps", {
                  attrs: {
                    stepInfo: _vm.statusNode,
                    statustype: _vm.auditStatus.status,
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.auditStatus.status == 3 &&
      _vm.statusNode.closeStatus != 1 &&
      _vm.modifyOrder
        ? _c(
            "div",
            {
              staticClass: "contentDetails",
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c("div", [
                _vm._m(1),
                _c("div", { staticStyle: { "margin-top": "20px" } }, [
                  _c("span", [
                    _vm._v("审批人：" + _vm._s(_vm.auditStatus.userName)),
                  ]),
                  _c("span", { staticStyle: { "padding-left": "20px" } }, [
                    _vm._v(
                      "审批时间：" +
                        _vm._s(
                          _vm.auditStatus.updateTime
                            ? _vm.auditStatus.updateTime
                            : "-"
                        )
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "boldSize16",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c("p", { staticStyle: { color: "#4c81eb" } }, [
                      _vm._v("不通过原因"),
                    ]),
                    _c("p", { staticStyle: { "margin-top": "5px" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.auditStatus.reason
                              ? _vm.auditStatus.reason
                              : "-"
                          ) +
                          " "
                      ),
                    ]),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm.statusNode.closeStatus == 1 && _vm.modifyOrder
        ? _c(
            "div",
            {
              staticClass: "contentDetails",
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c("div", [
                _vm._m(2),
                _c("div", { staticStyle: { "margin-top": "18px" } }, [
                  _c("span", [
                    _vm._v(
                      "操作人：" +
                        _vm._s(
                          _vm.closeMessage.userName
                            ? _vm.closeMessage.userName
                            : "-"
                        )
                    ),
                  ]),
                  _c("span", { staticStyle: { "padding-left": "20px" } }, [
                    _vm._v(
                      "关闭时间：" +
                        _vm._s(
                          _vm.closeMessage.closeTime
                            ? _vm.closeMessage.closeTime
                            : "-"
                        )
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "16px",
                      "font-size": "16px",
                      "font-weight": "400",
                    },
                  },
                  [
                    _c("span", { staticStyle: { color: "#4168e7" } }, [
                      _vm._v("关闭原因"),
                    ]),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-top": "5px",
                          "margin-left": "20px",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.closeMessage.closeReason
                              ? _vm.closeMessage.cause
                              : "-"
                          )
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm.modifyOrder &&
      _vm.auditStatus.status != 3 &&
      _vm.statusNode.closeStatus !== 1 &&
      (_vm.statusNode.subsetStatus == 3 ||
        _vm.statusNode.subsetStatus == 4 ||
        _vm.statusNode.subsetStatus == 22 ||
        _vm.statusNode.status == 3 ||
        _vm.statusNode.status == 4)
        ? _c(
            "div",
            {
              staticClass: "contentDetails",
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
              },
            },
            [
              _c("div", { staticStyle: { width: "100%" } }, [
                _vm.afterRecords.length > 0
                  ? _c("div", [
                      _vm.afterRecords.indexOf("8") == -1
                        ? _c("img", {
                            staticStyle: { "margin-right": "8px" },
                            attrs: {
                              src: require("../../assets/icon_guanbi.png"),
                            },
                          })
                        : _c("img", {
                            staticStyle: { "margin-right": "8px" },
                            attrs: {
                              src: require("../../assets/icon_wanc.png"),
                            },
                          }),
                      _vm.afterRecords.indexOf("8") == -1
                        ? _c("span", { staticClass: "boldSize" }, [
                            _vm._v("售后进行中"),
                          ])
                        : _c("span", { staticClass: "boldSize" }, [
                            _vm._v("售后完成"),
                          ]),
                    ])
                  : _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: { "margin-right": "8px" },
                          attrs: { src: require("../../assets/icon_wanc.png") },
                        }),
                        _c("span", { staticClass: "boldSize" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.statusNode.subsetStatus == 3
                                  ? "备货中，等待卖家备货"
                                  : "" ||
                                    _vm.statusNode.subsetStatus == 22 ||
                                    _vm.statusNode.subsetStatus == 4
                                  ? "已备货，等待卖家发货"
                                  : "" || _vm.statusNode.status == 3
                                  ? "等待买家确认签收"
                                  : "" || _vm.statusNode.status == 4
                                  ? "已签收"
                                  : ""
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                _vm.packageMessage.length == 0
                  ? _c("div", { staticClass: "approver" }, [_vm._v("收货信息")])
                  : _vm._e(),
                (_vm.statusNode.subsetStatus == 3 ||
                  _vm.statusNode.subsetStatus == 4 ||
                  _vm.statusNode.subsetStatus == 22) &&
                _vm.packageMessage.length == 0
                  ? _c(
                      "p",
                      {
                        staticClass: "size14",
                        staticStyle: { "margin-top": "6px" },
                      },
                      [_vm._v(" 使用物流配送 ")]
                    )
                  : _vm._e(),
                (_vm.statusNode.status == 3 || _vm.statusNode.status == 4) &&
                _vm.packageMessage.length == 0
                  ? _c(
                      "p",
                      {
                        staticClass: "size14",
                        staticStyle: { "margin-top": "6px" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.logisticsMessage.logisticsCompanyName)
                          ),
                        ]),
                        _c(
                          "span",
                          { staticStyle: { "padding-left": "10px" } },
                          [_vm._v(_vm._s(_vm.logisticsMessage.logisticsNumber))]
                        ),
                      ]
                    )
                  : _vm._e(),
                (_vm.statusNode.status == 3 || _vm.statusNode.status == 4) &&
                _vm.packageMessage.length != 0
                  ? _c(
                      "div",
                      {
                        staticClass: "size14",
                        staticStyle: {
                          "margin-top": "6px",
                          width: "100%",
                          display: "flex",
                        },
                      },
                      _vm._l(_vm.packageMessage, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: { display: "flex", width: "30%" },
                          },
                          [
                            _c("div", [_vm._v("包裹" + _vm._s(index + 1))]),
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c("div", [
                                  _c("span", [
                                    _vm._v(_vm._s(item.logisticsCompanyName)),
                                  ]),
                                  _c(
                                    "span",
                                    { staticStyle: { "padding-left": "10px" } },
                                    [_vm._v(_vm._s(item.logisticsNo))]
                                  ),
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "whiteBtn",
                                    staticStyle: { "margin-left": "10px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.examine1(item.logisticsNo)
                                      },
                                    },
                                  },
                                  [_vm._v("查看物流")]
                                ),
                              ],
                              1
                            ),
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                (_vm.statusNode.status == 3 || _vm.statusNode.status == 4) &&
                _vm.packageMessage.length == 0
                  ? _c(
                      "div",
                      {
                        staticClass: "size14",
                        staticStyle: { "margin-top": "6px" },
                      },
                      [
                        _vm.packageMessage.length == 0
                          ? _c("div", { staticClass: "approver" }, [
                              _vm._v("收货信息"),
                            ])
                          : _vm._e(),
                        (_vm.statusNode.subsetStatus == 3 ||
                          _vm.statusNode.subsetStatus == 4 ||
                          _vm.statusNode.subsetStatus == 22) &&
                        _vm.packageMessage.length == 0
                          ? _c(
                              "p",
                              {
                                staticClass: "size14",
                                staticStyle: { "margin-top": "6px" },
                              },
                              [_vm._v(" 使用物流配送 ")]
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm.packageMessage.length == 0
                ? _c(
                    "div",
                    { staticClass: "logisticsBtn" },
                    [
                      _vm.statusNode.status == 3 || _vm.statusNode.status == 4
                        ? _c(
                            "el-button",
                            {
                              staticClass: "whiteBtn",
                              on: { click: _vm.examine },
                            },
                            [_vm._v("查看物流")]
                          )
                        : _vm._e(),
                      _vm.statusNode.subsetStatus == 4 &&
                      (_vm.parArray.indexOf("deliverGoodsCode") != -1 ||
                        _vm.parArrayTwo.indexOf("wuliu_deliverGoodsCode") !=
                          -1) &&
                      _vm.orgName == "物流中心"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "whiteBtn",
                              on: { click: _vm.shipments },
                            },
                            [_vm._v("发 货")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "contentDetails" }, [
        _c(
          "div",
          {
            staticClass: "title",
            staticStyle: { display: "flex", "align-items": "center" },
          },
          [
            _vm._v(" 订单信息 "),
            _vm.saleAfter === "saleAfter"
              ? _c("div", { staticClass: "saleAfterType" }, [
                  _vm._v(" " + _vm._s(_vm.orderMessage.orderTypeLabel) + " "),
                ])
              : _vm._e(),
          ]
        ),
        _c("div", { staticClass: "order_details" }, [
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单号"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.orderNo ? _vm.orderMessage.orderNo : "-"
                  )
                ),
              ]),
            ]),
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("关联订单号"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.platformOrderNo
                      ? _vm.orderMessage.platformOrderNo
                      : "-"
                  )
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _vm.saleAfter != "saleAfter"
              ? _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("订单类型"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orderTypeLabel
                          ? _vm.orderMessage.orderTypeLabel
                          : "-"
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.saleAfter != "saleAfter"
              ? _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("入线时间"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.ditchTime
                          ? _vm.orderMessage.ditchTime
                          : "-"
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.saleAfter === "saleAfter"
              ? _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("创建时间"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(_vm._s(_vm.statusNode.buyerPlaceOrderTime)),
                  ]),
                ])
              : _vm._e(),
            _vm.saleAfter === "saleAfter"
              ? _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("订单分类"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orderGenerateTypeLabel
                          ? _vm.orderMessage.orderGenerateTypeLabel
                          : "-"
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("支付方式"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.payTypeCN
                      ? _vm.orderMessage.payTypeCN
                      : "-"
                  )
                ),
              ]),
            ]),
            _vm.saleAfter != "saleAfter"
              ? _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("跟进客服"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.follower
                          ? _vm.orderMessage.follower
                          : "-"
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.saleAfter === "saleAfter"
              ? _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("支付时间"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(_vm._s(_vm.statusNode.paidTime || "-")),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("平台"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.platformName
                      ? _vm.orderMessage.platformName
                      : "-"
                  )
                ),
              ]),
            ]),
            _vm.saleAfter != "saleAfter"
              ? _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("部门"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orgName
                          ? _vm.orderMessage.orgName
                          : "-"
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.saleAfter === "saleAfter"
              ? _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("购买类型"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(_vm._s(_vm.afterSaleInfo.buyType || "-")),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("来源渠道"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.userDitch
                      ? _vm.orderMessage.userDitch
                      : "-"
                  )
                ),
              ]),
            ]),
            _vm.saleAfter != "saleAfter"
              ? _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("订单分类"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.orderGenerateTypeLabel
                          ? _vm.orderMessage.orderGenerateTypeLabel
                          : "-"
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "blankBox" }),
          _c("div", { staticClass: "order_details_box" }, [
            _c("div", { staticClass: "order_details_item" }, [
              _c("span", { staticClass: "order_details_title" }, [
                _vm._v("订单来源"),
              ]),
              _c("span", { staticClass: "order_details_value" }, [
                _vm._v(_vm._s(_vm.orderMessage.orderSource || "-")),
              ]),
            ]),
            _vm.saleAfter != "saleAfter"
              ? _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("第三方平台"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(_vm._s(_vm.orderMessage.thirdPartyPlatform || "-")),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm.orderMessage.orderTypeLabel == "积分订单"
            ? _c("div", { staticClass: "blankBox" })
            : _vm._e(),
          _vm.orderMessage.orderTypeLabel == "积分订单"
            ? _c("div", { staticClass: "order_details_box" }, [
                _c("div", { staticClass: "order_details_item" }, [
                  _c("span", { staticClass: "order_details_title" }, [
                    _vm._v("支付积分"),
                  ]),
                  _c("span", { staticClass: "order_details_value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.orderMessage.usePointsNum
                          ? _vm.orderMessage.usePointsNum
                          : "-"
                      )
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "remarkMessage" }, [
          _c("div", { staticClass: "remarkMessage_remark" }, [
            _c("div", { staticClass: "remarkMessage_remark_item" }, [
              _c("span", { staticClass: "fourteenTitle" }, [
                _vm._v("备注信息"),
              ]),
              _c("span", { staticClass: "fourteenDetails" }, [
                _vm._v(
                  _vm._s(
                    _vm.orderMessage.remarks
                      ? _vm.orderMessage.remarks
                      : "暂无备注 "
                  )
                ),
              ]),
              _vm.statusNode.status == 1 || _vm.statusNode.status == 5
                ? _c(
                    "span",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            disabled:
                              _vm.statusNode.closeStatus == 1 ? true : false,
                            type: "text",
                          },
                          on: { click: _vm.addRemarkBtn },
                        },
                        [_vm._v("添加备注")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _c("div", { staticClass: "remarkMessage_remark_item" }, [
              _c("span", { staticClass: "fourteenTitle" }, [
                _vm._v("审批备注"),
              ]),
              _c(
                "span",
                { staticClass: "fourteenDetails" },
                _vm._l(_vm.records, function (item, index) {
                  return _c("span", { key: index }, [
                    item.userName != ""
                      ? _c(
                          "span",
                          { staticStyle: { "margin-right": "20px" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(item.userName) +
                                " : " +
                                _vm._s(item.reason) +
                                " "
                            ),
                          ]
                        )
                      : _c(
                          "span",
                          { staticStyle: { "margin-right": "20px" } },
                          [_vm._v(" " + _vm._s("暂无备注") + " ")]
                        ),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ]),
      ]),
      _vm.saleAfter === "saleAfter"
        ? _c("div", { staticClass: "contentDetails" }, [
            _c("div", { staticClass: "title" }, [_vm._v("关联信息")]),
            _c("div", { staticStyle: { "margin-top": "14px" } }, [
              _vm._m(3),
              _c("div", { staticClass: "about-item-box about-item-info-box" }, [
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v(" ￥" + _vm._s(_vm.afterSaleInfo.allMoney) + " "),
                ]),
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v(" ￥" + _vm._s(_vm.afterSaleInfo.otherMoney) + " "),
                ]),
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v("￥" + _vm._s(_vm.afterSaleInfo.balance)),
                ]),
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v(" ￥" + _vm._s(_vm.afterSaleInfo.couponVal) + " "),
                ]),
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v(_vm._s(_vm.afterSaleInfo.usePoints)),
                ]),
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v("￥" + _vm._s(_vm.afterSaleInfo.freight)),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "about-item-box about-item-title-box" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "about-item about-title",
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "center",
                      },
                    },
                    [
                      _vm._v(" 订单实付金额 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "订单实付金额=在线支付金额+余额支付金额",
                            placement: "top",
                          },
                        },
                        [
                          _c("div", { staticClass: "about-tips" }, [
                            _vm._v("?"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "about-item about-title" }, [
                    _vm._v("业绩归属部门"),
                  ]),
                  _c("div", { staticClass: "about-item about-title" }, [
                    _vm._v("业绩归属人"),
                  ]),
                  _c("div", { staticClass: "about-item about-title" }, [
                    _vm._v("上级信息"),
                  ]),
                  _c("div", { staticClass: "about-item about-title" }, [
                    _vm._v("上级绑定时间"),
                  ]),
                  _c("div", { staticClass: "about-item about-title" }, [
                    _vm._v("上级礼包结算阶梯"),
                  ]),
                ]
              ),
              _c("div", { staticClass: "about-item-box about-item-info-box" }, [
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v(" ￥" + _vm._s(_vm.afterSaleInfo.orderMoney) + " "),
                ]),
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.afterSaleInfo.achievementDeptName || "-") +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.afterSaleInfo.achievementUserName || "-") +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v(
                    " " + _vm._s(_vm.afterSaleInfo.upLevelName || "-") + " "
                  ),
                  _c("p", [_vm._v(_vm._s(_vm.afterSaleInfo.upLevelPhone))]),
                ]),
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v(
                    " " + _vm._s(_vm.afterSaleInfo.upBindTime || "-") + " "
                  ),
                ]),
                _c("div", { staticClass: "about-item about-info" }, [
                  _vm._v(
                    " " + _vm._s(_vm.afterSaleInfo.upGiftLevel || "-") + " "
                  ),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "about-item-box about-item-title-box" },
                [
                  _c("div", { staticClass: "about-item about-title" }),
                  _c("div", { staticClass: "about-item about-title" }, [
                    _vm._v("上级佣金比例"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "about-item about-title",
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "center",
                      },
                    },
                    [
                      _vm._v(" 上级佣金 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "根据订单实付金额*上级佣金比例得出此数值",
                            placement: "top",
                          },
                        },
                        [
                          _c("div", { staticClass: "about-tips" }, [
                            _vm._v("?"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "about-item about-title" }, [
                    _vm._v("自身佣金比例"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "about-item about-title",
                      staticStyle: {
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "center",
                      },
                    },
                    [
                      _vm._v(" 自身佣金 "),
                      _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "dark",
                            content: "根据订单实付金额*自身佣金比例得出此数值",
                            placement: "top",
                          },
                        },
                        [
                          _c("div", { staticClass: "about-tips" }, [
                            _vm._v("?"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "about-item about-title" }, [
                    _vm._v("获得积分"),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "about-item-box about-item-info-box",
                  staticStyle: { "border-bottom": "1px solid #e8eaec" },
                },
                [
                  _c("div", { staticClass: "about-item about-info" }),
                  _c("div", { staticClass: "about-item about-info" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.afterSaleInfo.upCommissionProportion || "-"
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "about-item about-info" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.afterSaleInfo.upCommission
                            ? "￥" + _vm.afterSaleInfo.upCommission
                            : "-"
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "about-item about-info" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.afterSaleInfo.selfCommissionProportion || "-"
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "about-item about-info" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.afterSaleInfo.selfCommission
                            ? "￥" + _vm.afterSaleInfo.selfCommission
                            : "-"
                        ) +
                        " "
                    ),
                  ]),
                  _c("div", { staticClass: "about-item about-info" }, [
                    _vm._v(_vm._s(_vm.afterSaleInfo.getPoints)),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      _c("div", { staticClass: "contentDetails" }, [
        _c("div", { staticClass: "title" }, [_vm._v("购买信息")]),
        _c("div", { staticClass: "contentDetails_box" }, [
          _c("div", { staticClass: "contentDetails_item" }, [
            _c("div", { staticClass: "title_too" }, [_vm._v("收货信息")]),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("收货人"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.postName ? _vm.buyMessage.postName : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("联系方式"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.postContact
                        ? _vm.buyMessage.postContact
                        : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item addressWidth" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("收货地址"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.postProvinceCod
                        ? _vm.buyMessage.postProvinceCode +
                            _vm.buyMessage.postCityCode +
                            _vm.buyMessage.postDetailedAddress
                        : _vm.buyMessage.postAddress
                    )
                  ),
                ]),
                _vm.auditStatus.status == 1 &&
                (_vm.statusNode.status == 1 ||
                  _vm.statusNode.subsetStatus == 2 ||
                  _vm.statusNode.subsetStatus == 3 ||
                  _vm.statusNode.subsetStatus == 22) &&
                _vm.orderMessage.canDoApprove == 1 &&
                _vm.modifyOrder
                  ? _c(
                      "span",
                      { staticStyle: { "padding-left": "20px" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled:
                                _vm.statusNode.closeStatus == 1 ? true : false,
                              type: "text",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.amendAddress("addressEdit")
                              },
                            },
                          },
                          [_vm._v("修改")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "borderWire" }),
          _c("div", { staticClass: "contentDetails_item" }, [
            _c("div", { staticClass: "title_too" }, [_vm._v("买家信息")]),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("客户姓名"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.userName ? _vm.buyMessage.userName : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("客户电话"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.userPhone ? _vm.buyMessage.userPhone : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("客户意向"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.userIntentionLabel
                        ? _vm.buyMessage.userIntentionLabel
                        : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("span", { staticClass: "details_title fourteen" }, [
                  _vm._v("买家留言"),
                ]),
                _c("span", { staticClass: "details_value fourteen" }, [
                  _vm._v(
                    _vm._s(
                      _vm.buyMessage.userRemarks
                        ? _vm.buyMessage.userRemarks
                        : "-"
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "contentDetails" },
        [
          _c("div", { staticClass: "titleBtn" }, [
            _c(
              "div",
              {
                staticClass: "title",
                staticStyle: { "margin-bottom": "20px" },
              },
              [
                _c("label", [_vm._v("商品信息")]),
                _vm.orderMessage.vipName && _vm.orderMessage.orderType == "5"
                  ? _c("label", { staticClass: "vipName" }, [
                      _vm._v(_vm._s(_vm.orderMessage.vipName + "订单")),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm.orderMessage.sysUserId == _vm.userId &&
            _vm.parArray.indexOf("afterSaleCode") != -1 &&
            (_vm.statusNode.status == 4 || _vm.statusNode.status == 3)
              ? _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "afterSales",
                        attrs: {
                          type: "danger",
                          plain: "",
                          disabled: _vm.goodsListDialog.length === 0,
                        },
                        on: { click: _vm.handlerAfterSale },
                      },
                      [_vm._v("售后")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm.orderMessage.orderType == 10
            ? _c(
                "div",
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.goodsMessage1,
                        "header-cell-style": {
                          background: "#fafafa",
                          color: "#333333",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "updatedTime",
                          label: "商品信息",
                          headerAlign: "left",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _vm.orderMessage.orderType == "6"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(props.row.giftPackageName)
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "text-align": "left",
                                              },
                                            },
                                            _vm._l(
                                              props.row.giftGoods,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticStyle: {
                                                      display: "flex",
                                                    },
                                                  },
                                                  [
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(item.goodsName) +
                                                          " " +
                                                          _vm._s(
                                                            item.goodsSkuName
                                                          ) +
                                                          "*" +
                                                          _vm._s(
                                                            item.goodsQuantity
                                                          )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                          _c("p", [
                                            _vm._v(
                                              "礼包编码：" +
                                                _vm._s(
                                                  props.row.giftPackageCode
                                                    ? props.row.giftPackageCode
                                                    : "-"
                                                )
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: { "text-align": "left" },
                                        },
                                        [
                                          _c("div", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  props.row.goodsName
                                                    ? props.row.goodsName
                                                    : "-"
                                                )
                                              ),
                                            ]),
                                            props.row.goodsType == "3"
                                              ? _c(
                                                  "span",
                                                  { staticClass: "gift" },
                                                  [_vm._v("赠品")]
                                                )
                                              : _vm._e(),
                                          ]),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                props.row.goodsSkuName
                                                  ? props.row.goodsSkuName
                                                  : "-"
                                              )
                                            ),
                                          ]),
                                          _c("p", [
                                            _vm._v(
                                              "商品编码：" +
                                                _vm._s(
                                                  props.row.goodsNo
                                                    ? props.row.goodsNo
                                                    : "-"
                                                )
                                            ),
                                          ]),
                                        ]
                                      ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2733032954
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "authListStr",
                          label: "定制图片",
                          headerAlign: "left",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("div", {
                                    staticStyle: { "text-align": "left" },
                                    attrs: {
                                      "v-html": props.row.customizeImage,
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1474922933
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "authListStr",
                          label: "单价/数量",
                          "header-align": "left",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "left" } },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "￥" +
                                            _vm._s(
                                              props.row.retailPrice ||
                                                props.row.unitPrice
                                            )
                                        ),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          "× " + _vm._s(props.row.quantity)
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1739808693
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "authListStr",
                          label: "定制信息",
                          "header-align": "left",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("div", {
                                    staticStyle: { "text-align": "left" },
                                    attrs: {
                                      "v-html": props.row.customizeMessage,
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1114013721
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "authListStr",
                          label: "定制费用",
                          "header-align": "left",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c("div", {
                                    staticStyle: { "text-align": "left" },
                                    attrs: {
                                      "v-html": props.row.customizePrice,
                                    },
                                  }),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          680925599
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "authListStr",
                          label: "小计",
                          "header-align": "right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "实付￥" +
                                            _vm._s(props.row.amountPaid)
                                        ),
                                      ]),
                                      props.row.subtotal
                                        ? _c("p", [
                                            _vm._v(
                                              "￥" + _vm._s(props.row.subtotal)
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          766583471
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "authListStr",
                          label: "其他信息",
                          "header-align": "right",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    { staticStyle: { "text-align": "right" } },
                                    [
                                      props.row.subsetStatus != "售后关闭" &&
                                      props.row.status != 0 &&
                                      props.row.refundMoney
                                        ? _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(props.row.statusCn) +
                                                ":￥" +
                                                _vm._s(props.row.refundMoney) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                      props.row.subsetStatus
                                        ? _c("p", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  props.row.subsetStatus ==
                                                    "无售后"
                                                    ? "-"
                                                    : props.row.subsetStatus
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                      props.row.subsetStatus != "售后关闭" &&
                                      props.row.afterSaleReason
                                        ? _c("p", [
                                            _vm._v(
                                              " 售后原因:" +
                                                _vm._s(
                                                  props.row.afterSaleReason
                                                    ? props.row.afterSaleReason
                                                    : "-"
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2402657094
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("div", [
                _vm.packageMessage.length == 0
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.goodsMessage,
                              "header-cell-style": {
                                background: "#fafafa",
                                color: "#333333",
                              },
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "updatedTime",
                                label: "商品信息",
                                headerAlign: "left",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _vm.orderMessage.orderType == "6"
                                          ? _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "left",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.row.giftPackageName
                                                    )
                                                  ),
                                                ]),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "text-align": "left",
                                                    },
                                                  },
                                                  _vm._l(
                                                    props.row.giftGoods,
                                                    function (item, index) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: index,
                                                          staticStyle: {
                                                            display: "flex",
                                                          },
                                                        },
                                                        [
                                                          _c("div", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.goodsName
                                                              ) +
                                                                " " +
                                                                _vm._s(
                                                                  item.goodsSkuName
                                                                ) +
                                                                "*" +
                                                                _vm._s(
                                                                  item.goodsQuantity
                                                                )
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _c("p", [
                                                  _vm._v(
                                                    "礼包编码：" +
                                                      _vm._s(
                                                        props.row
                                                          .giftPackageCode
                                                          ? props.row
                                                              .giftPackageCode
                                                          : "-"
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  "text-align": "left",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        props.row.goodsName
                                                          ? props.row.goodsName
                                                          : "-"
                                                      )
                                                    ),
                                                  ]),
                                                  props.row.goodsType == "3"
                                                    ? _c(
                                                        "span",
                                                        { staticClass: "gift" },
                                                        [_vm._v("赠品")]
                                                      )
                                                    : _vm._e(),
                                                ]),
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      props.row.goodsSkuName
                                                        ? props.row.goodsSkuName
                                                        : "-"
                                                    )
                                                  ),
                                                ]),
                                                _c("p", [
                                                  _vm._v(
                                                    "商品编码：" +
                                                      _vm._s(
                                                        props.row.goodsNo
                                                          ? props.row.goodsNo
                                                          : "-"
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2733032954
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "authListStr",
                                label: "单价/数量",
                                "header-align": "right",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                "￥" +
                                                  _vm._s(
                                                    props.row.retailPrice ||
                                                      props.row.unitPrice
                                                  )
                                              ),
                                            ]),
                                            _c("p", [
                                              _vm._v(
                                                "× " +
                                                  _vm._s(props.row.quantity)
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4036580942
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "authListStr",
                                label: "小计",
                                "header-align": "right",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            _c("p", [
                                              _vm._v(
                                                "实付￥" +
                                                  _vm._s(props.row.amountPaid)
                                              ),
                                            ]),
                                            props.row.subtotal
                                              ? _c("p", [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(props.row.subtotal)
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                766583471
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "authListStr",
                                label: "其他信息",
                                "header-align": "right",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (props) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "right",
                                            },
                                          },
                                          [
                                            props.row.subsetStatus !=
                                              "售后关闭" &&
                                            props.row.status != 0 &&
                                            props.row.refundMoney
                                              ? _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row.statusCn
                                                      ) +
                                                      ":￥" +
                                                      _vm._s(
                                                        props.row.refundMoney
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            props.row.subsetStatus
                                              ? _c("p", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        props.row
                                                          .subsetStatus ==
                                                          "无售后"
                                                          ? "-"
                                                          : props.row
                                                              .subsetStatus
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                            props.row.subsetStatus !=
                                              "售后关闭" &&
                                            props.row.afterSaleReason
                                              ? _c("p", [
                                                  _vm._v(
                                                    " 售后原因:" +
                                                      _vm._s(
                                                        props.row
                                                          .afterSaleReason
                                                          ? props.row
                                                              .afterSaleReason
                                                          : "-"
                                                      ) +
                                                      " "
                                                  ),
                                                ])
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4221102022
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      _vm._l(_vm.packageMessage, function (item, index) {
                        return _c(
                          "div",
                          { key: index, staticStyle: { "margin-top": "10px" } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "16px",
                                      "font-family": "PingFang SC",
                                      "font-weight": "bold",
                                      "line-height": "30px",
                                      color: "#333333",
                                    },
                                  },
                                  [_vm._v(" 包裹" + _vm._s(index + 1))]
                                ),
                                (_vm.statusNode.status == 3 ||
                                  _vm.statusNode.status == 4) &&
                                _vm.parArray.indexOf("affirmsignForCode") !=
                                  -1 &&
                                _vm.modifyOrder &&
                                _vm.saleAfter != "saleAfter" &&
                                _vm.orderMessage.orderGenerateType == 1 &&
                                item.subStatus != 6
                                  ? _c(
                                      "el-button",
                                      {
                                        staticStyle: {
                                          width: "120px",
                                          height: "36px",
                                          "line-height": "0",
                                          "margin-left": "20px",
                                        },
                                        attrs: { type: "primary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.takeDeliveryOfGoods1(
                                              item.subId
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("确认收货")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _c("ordersListDetailTable", {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading",
                                },
                              ],
                              attrs: {
                                dataList: item.goodsList,
                                config: _vm.columnCommon.config,
                                subOrderNo: item.subOrderNo,
                                status: item.status,
                                splitTime: item.splitTime,
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    ),
              ]),
          _c("div", { staticClass: "fourteenDetails_title" }, [
            _vm._v("优惠信息"),
          ]),
          _vm.saleAfter === "saleAfter"
            ? _c("div", [
                _vm.afterSaleInfo.couponVal > 0
                  ? _c("p", [
                      _vm._v(
                        " 优惠券 -￥" +
                          _vm._s(_vm.afterSaleInfo.couponVal) +
                          " "
                      ),
                    ])
                  : _c("p", [_vm._v("无优惠")]),
              ])
            : [
                _vm.orderMessage.platformDiscount == 0 &&
                _vm.orderMessage.shopDiscount == 0
                  ? _c(
                      "div",
                      {
                        staticClass: "fourteenDetails",
                        staticStyle: {
                          "margin-top": "12px",
                          "border-bottom": "1px solid #ededed",
                          "padding-bottom": "20px",
                        },
                      },
                      [_vm._v(" 无优惠 ")]
                    )
                  : _c("div", { staticClass: "fourteenDetails" }, [
                      _c("div", { staticClass: "fourteenDetails_item" }, [
                        _c(
                          "div",
                          { staticClass: "fourteenDetails_item_title" },
                          [_vm._v("平台优惠")]
                        ),
                        _c("div", { staticClass: "red" }, [
                          _vm._v(
                            "￥" + _vm._s(_vm.orderMessage.platformDiscount)
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "fourteenDetails_item" }, [
                        _c(
                          "div",
                          { staticClass: "fourteenDetails_item_title" },
                          [_vm._v("商家优惠")]
                        ),
                        _c("div", { staticClass: "red" }, [
                          _vm._v("￥" + _vm._s(_vm.orderMessage.shopDiscount)),
                        ]),
                      ]),
                      _c("div", { staticClass: "fourteenDetails_item" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "fourteenDetails_item_title fontWeight red",
                          },
                          [_vm._v(" 优惠总额 ")]
                        ),
                        _c("div", { staticClass: "fontWeight red" }, [
                          _vm._v(
                            " ￥" +
                              _vm._s(
                                Number(_vm.orderMessage.shopDiscount) +
                                  Number(_vm.orderMessage.platformDiscount)
                              ) +
                              " "
                          ),
                        ]),
                      ]),
                    ]),
              ],
          _c("div", { staticClass: "total_prices" }, [
            _vm.orderMessage.orderType == 10
              ? _c(
                  "span",
                  { staticStyle: { color: "#666666", "margin-right": "15px" } },
                  [
                    _vm._v(
                      "定制费总价：￥" +
                        _vm._s(
                          _vm.orderMessage.customizedPrice
                            ? _vm.orderMessage.customizedPrice
                            : "0"
                        )
                    ),
                  ]
                )
              : _vm._e(),
            _c(
              "span",
              { staticStyle: { color: "#666666", "margin-right": "15px" } },
              [
                _vm._v(
                  "商品总价：￥" +
                    _vm._s(
                      _vm.orderMessage.totalAmount
                        ? _vm.orderMessage.totalAmount
                        : "0"
                    )
                ),
              ]
            ),
            _c(
              "span",
              { staticStyle: { color: "#666666", "margin-right": "15px" } },
              [
                _vm._v(
                  "运费：￥" +
                    _vm._s(
                      _vm.orderMessage.freightAmount
                        ? _vm.orderMessage.freightAmount
                        : "0"
                    )
                ),
              ]
            ),
            _c(
              "span",
              { staticStyle: { color: "red", "margin-right": "15px" } },
              [
                _vm._v(
                  "优惠：￥" +
                    _vm._s(
                      _vm.orderMessage.discountAmount
                        ? _vm.orderMessage.discountAmount
                        : "0"
                    )
                ),
              ]
            ),
            _c(
              "span",
              {
                staticClass: "fontWeight",
                staticStyle: { color: "#444", "margin-right": "15px" },
              },
              [
                _vm._v(
                  "应付：￥" +
                    _vm._s(
                      _vm.orderMessage.receivableAmount
                        ? _vm.orderMessage.receivableAmount
                        : "0"
                    )
                ),
              ]
            ),
            _c(
              "span",
              { staticClass: "fontWeight", staticStyle: { color: "#6190ed" } },
              [
                _vm._v(
                  "（实付：￥" +
                    _vm._s(
                      _vm.orderMessage.receivedAmount
                        ? _vm.orderMessage.receivedAmount
                        : "0"
                    ) +
                    "）"
                ),
              ]
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "botton_btn" }, [
        _c(
          "div",
          [
            _vm.statusNode.closeStatus != 1 &&
            _vm.shenheState &&
            _vm.parArray.indexOf("auditCode") != -1 &&
            _vm.auditStatus.status == 1 &&
            this.auditState == true &&
            _vm.modifyOrder &&
            _vm.orderMessage.canDoApprove == 1
              ? _c(
                  "el-button",
                  {
                    staticClass: "whiteBtn",
                    attrs: { type: "primary", plain: "" },
                    on: { click: _vm.handlerAudit },
                  },
                  [_vm._v("审核")]
                )
              : _vm._e(),
            _vm.statusNode.subsetStatus == 3 &&
            _vm.logistics &&
            (_vm.parArray.indexOf("stockUpCode") != -1 ||
              _vm.parArrayTwo.indexOf("wuliu_stockUpCode") != -1) &&
            _vm.orgName == "物流中心" &&
            _vm.modifyOrder
              ? _c(
                  "el-button",
                  {
                    staticClass: "whiteBtn",
                    staticStyle: {
                      width: "120px",
                      height: "36px",
                      "line-height": "0",
                    },
                    attrs: { type: "primary", plain: "" },
                    on: { click: _vm.stockUp },
                  },
                  [_vm._v("备货")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          [
            _vm.auditStatus.status == 3 &&
            _vm.parArray.indexOf("anewSubmitCode") != -1 &&
            _vm.orderMessage.sysUserId == _vm.userId &&
            _vm.statusNode.closeStatus != 1 &&
            _vm.modifyOrder
              ? _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "120px",
                      height: "36px",
                      "line-height": "0",
                    },
                    attrs: { type: "primary", plain: "" },
                    on: { click: _vm.handlerResubmit },
                  },
                  [_vm._v("重新提交")]
                )
              : _vm._e(),
            _vm.orgName != "物流中心"
              ? _c(
                  "span",
                  [
                    (_vm.auditStatus.status == 1 ||
                      _vm.statusNode.status == 1 ||
                      _vm.statusNode.subsetStatus == 1 ||
                      _vm.statusNode.subsetStatus == 2 ||
                      _vm.statusNode.subsetStatus == 3) &&
                    _vm.orderMessage.sysUserId == _vm.userId &&
                    _vm.parArray.indexOf("closeOrderCode") != -1 &&
                    _vm.modifyOrder
                      ? _c(
                          "el-button",
                          {
                            staticStyle: {
                              width: "120px",
                              height: "36px",
                              "line-height": "0",
                            },
                            attrs: {
                              type: "primary",
                              disabled:
                                _vm.statusNode.closeStatus == 1 ? true : false,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handlerCloseOrder("closeOrder")
                              },
                            },
                          },
                          [_vm._v("关闭订单")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.orgName == "物流中心"
              ? _c(
                  "span",
                  [
                    (_vm.auditStatus.status == 1 ||
                      _vm.statusNode.status == 1 ||
                      _vm.statusNode.subsetStatus == 1 ||
                      _vm.statusNode.subsetStatus == 2 ||
                      _vm.statusNode.subsetStatus == 3) &&
                    _vm.orgName == "物流中心" &&
                    _vm.parArrayTwo.indexOf("guanbiwuliudingdan") != -1 &&
                    _vm.modifyOrder
                      ? _c(
                          "el-button",
                          {
                            staticStyle: {
                              width: "120px",
                              height: "36px",
                              "line-height": "0",
                            },
                            attrs: {
                              type: "primary",
                              disabled:
                                _vm.statusNode.closeStatus == 1 ? true : false,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handlerCloseOrder("closeOrder")
                              },
                            },
                          },
                          [_vm._v("关闭订单")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.statusNode.status == 3 &&
            _vm.parArray.indexOf("affirmsignForCode") != -1 &&
            _vm.modifyOrder &&
            _vm.saleAfter != "saleAfter" &&
            _vm.packageMessage.length == 0
              ? _c(
                  "el-button",
                  {
                    staticStyle: {
                      width: "120px",
                      height: "36px",
                      "line-height": "0",
                    },
                    attrs: { type: "primary" },
                    on: { click: _vm.takeDeliveryOfGoods },
                  },
                  [_vm._v("确认收货")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type == "logisticsInformation"
            ? [
                _c("StepLogistics", {
                  attrs: { stepProgress: _vm.logisticsNode },
                }),
              ]
            : _vm._e(),
          _vm.dialog.type == "shipmentsCode"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "wuliu",
                    attrs: {
                      model: _vm.wuliu,
                      rules: _vm.wuliuRules,
                      "label-width": "80px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "出库仓库",
                          "label-width": "100px",
                          prop: "warehouse",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              placeholder: "请选择出库仓库",
                            },
                            model: {
                              value: _vm.wuliu.warehouse,
                              callback: function ($$v) {
                                _vm.$set(_vm.wuliu, "warehouse", $$v)
                              },
                              expression: "wuliu.warehouse",
                            },
                          },
                          _vm._l(_vm.commWarehouseList, function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "物流公司",
                          "label-width": "100px",
                          prop: "company",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              filterable: "",
                              placeholder: "请选择物流公司",
                            },
                            model: {
                              value: _vm.wuliu.company,
                              callback: function ($$v) {
                                _vm.$set(_vm.wuliu, "company", $$v)
                              },
                              expression: "wuliu.company",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.courier_company,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "物流单号",
                          "label-width": "100px",
                          prop: "odd",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            oninput: "value=value.replace(/[^\\w_]/g,'')",
                          },
                          model: {
                            value: _vm.wuliu.odd,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.wuliu,
                                "odd",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "wuliu.odd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "dialogBtn" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.dialog.visible = false
                              },
                            },
                          },
                          [_vm._v("取 消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.dialogSubmitwuliu("wuliu")
                              },
                            },
                          },
                          [_vm._v("确 定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addAddress"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.rules,
                      "label-width": "80px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "收货人姓名",
                          "label-width": "100px",
                          prop: "userName",
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.userName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "userName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.userName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "联系电话",
                          "label-width": "100px",
                          prop: "phone",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            oninput: "value=value.replace(/[^0-9.]/g,'')",
                            maxLength: 11,
                          },
                          model: {
                            value: _vm.form.phone,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "phone",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.phone",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "收货地址",
                          "label-width": "100px",
                          prop: "addressValue",
                        },
                      },
                      [
                        _c("el-cascader", {
                          attrs: {
                            options: _vm.addressOptions,
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.onChangeAddress },
                          model: {
                            value: _vm.form.addressValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "addressValue", $$v)
                            },
                            expression: "form.addressValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "详细地址",
                          "label-width": "100px",
                          prop: "detailedAddress",
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.form.detailedAddress,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "detailedAddress",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.detailedAddress",
                          },
                        }),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { "false-label": 0, "true-label": 1 },
                            model: {
                              value: _vm.form.isDefault,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "isDefault", $$v)
                              },
                              expression: "form.isDefault",
                            },
                          },
                          [_vm._v("设为默认 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "dialogBtn" },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.dialog.visible = false
                              },
                            },
                          },
                          [_vm._v("取 消")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.dialogSubmit("form")
                              },
                            },
                          },
                          [_vm._v("确 定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addRemark"
            ? [
                _c(
                  "el-form",
                  { attrs: { "label-width": "50px" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "备注" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 5,
                            placeholder: "请输入备注",
                          },
                          model: {
                            value: _vm.remark,
                            callback: function ($$v) {
                              _vm.remark = $$v
                            },
                            expression: "remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "dialogBtn" },
                  [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            _vm.dialog.visible = false
                          },
                        },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.confirmAddRemark },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addressAmend"
            ? [
                _c(
                  "span",
                  { staticClass: "addressHeader" },
                  [
                    _c("i", {
                      staticClass: "el-icon-circle-plus-outline",
                      staticStyle: { color: "#4168e7" },
                    }),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#4168e7" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.addAddress("Address")
                          },
                        },
                      },
                      [_vm._v("新增收货地址")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.siteDataList,
                      "header-cell-style": {
                        background: "#F8F8F9",
                        color: "#333333",
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "收货人", prop: "userName" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "手机号码", prop: "phone" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "地区", prop: "userName" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        props.row.provinceCode
                                          ? props.row.provinceCode +
                                              props.row.cityCode +
                                              props.row.regionCode
                                          : "-"
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        197606537
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "详细地址", prop: "detailedAddress" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "默认地址" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.defaultSite(props.row.id)
                                    },
                                  },
                                  model: {
                                    value: props.row.isDefault,
                                    callback: function ($$v) {
                                      _vm.$set(props.row, "isDefault", $$v)
                                    },
                                    expression: "props.row.isDefault",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        234956708
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.employ(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v("使用 ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dialogEdit(
                                          "editAddress",
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("编辑 ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dialogDelete(props.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("删除 ")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1854051084
                      ),
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogToo.title,
            visible: _vm.dialogToo.visible,
            width: _vm.dialogToo.width,
            "append-to-body": "",
            "before-close": _vm.handleCloseToo,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialogToo, "visible", $event)
            },
          },
        },
        [
          _vm.dialogToo.type == "selectPay"
            ? [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.selectPayment },
                    model: {
                      value: _vm.setPay.payment,
                      callback: function ($$v) {
                        _vm.$set(_vm.setPay, "payment", $$v)
                      },
                      expression: "setPay.payment",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "1" } }, [
                      _vm._v("在线支付"),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "setPayDialogBtn" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: { change: _vm.selectPayDefault },
                          model: {
                            value: _vm.setPay.payDefault,
                            callback: function ($$v) {
                              _vm.$set(_vm.setPay, "payDefault", $$v)
                            },
                            expression: "setPay.payDefault",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            { attrs: { label: "1", name: "type" } },
                            [_vm._v("设为默认")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_quxiao",
                          on: { click: _vm.handleCloseToo },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_queren",
                          attrs: { type: "primary" },
                          on: { click: _vm.confirmSelectPay },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.dialogToo.type == "payMoney"
            ? [
                _c("div", { staticClass: "payMoney" }, [
                  _c("div", [
                    _c("p", { staticClass: "payMoney_should" }, [
                      _vm._v(
                        " 应付:￥" +
                          _vm._s(_vm.orderMessage.receivableAmount) +
                          " "
                      ),
                    ]),
                    _c("p", { staticClass: "payMoney_already" }, [
                      _vm._v("已收:￥200.00"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "payMoney_box" },
                    [
                      _c("span", { staticClass: "payMoney_money" }, [
                        _vm._v("支付金额"),
                      ]),
                      _c("span", { staticClass: "payMoney_mo" }, [
                        _vm._v("￥"),
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "110px" },
                        attrs: {
                          controls: false,
                          mix: 0,
                          type: "number",
                          precision: 2,
                        },
                        model: {
                          value: _vm.paymentAmount,
                          callback: function ($$v) {
                            _vm.paymentAmount = $$v
                          },
                          expression: "paymentAmount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "payMoney_text" }, [
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v("总计: 共" + _vm._s(_vm.totalQuantity) + "件"),
                    ]),
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v("商品总价: ￥" + _vm._s(_vm.totalPrices)),
                    ]),
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v(
                        "运费: ￥" + _vm._s(_vm.orderMessage.freightAmount)
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "dialogBtnright" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_quxiao",
                          on: { click: _vm.handleCloseToo },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_queren",
                          attrs: { type: "primary" },
                          on: { click: _vm.onlinePayment },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.dialogToo.type == "closeOrder"
            ? [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.setCloseOrder,
                      callback: function ($$v) {
                        _vm.setCloseOrder = $$v
                      },
                      expression: "setCloseOrder",
                    },
                  },
                  _vm._l(
                    _vm.dictionaries.order_main_close_reason,
                    function (item, index) {
                      return _c(
                        "el-radio",
                        {
                          key: index,
                          staticClass: "setPay_payment",
                          attrs: { label: item.dictId },
                        },
                        [_vm._v(_vm._s(item.dictName))]
                      )
                    }
                  ),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.handleCloseToo },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.handlerCloseOrderSubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialogToo.type == "audit"
            ? [
                _c("div", { staticClass: "audit_title" }, [
                  _vm._v("是否审核通过？"),
                ]),
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.handlerSelect },
                    model: {
                      value: _vm.selectShenhe,
                      callback: function ($$v) {
                        _vm.selectShenhe = $$v
                      },
                      expression: "selectShenhe",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "2" } }, [_vm._v("通过")]),
                    _c("el-radio", { attrs: { label: "3" } }, [
                      _vm._v("不通过"),
                    ]),
                  ],
                  1
                ),
                _vm.selectShenhe == 3
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "audit_textarea",
                            attrs: { "label-width": "40px" },
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "原因" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "请输入原因",
                                    maxlength: "200",
                                    "show-word-limit": "",
                                    type: "textarea",
                                  },
                                  model: {
                                    value: _vm.cause,
                                    callback: function ($$v) {
                                      _vm.cause = $$v
                                    },
                                    expression: "cause",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.handleCloseToo },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.handlerAuditsubmit },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          staticClass: "dialogafterSaleClass",
          attrs: {
            title: _vm.dialogAfterSale.title,
            visible: _vm.dialogAfterSale.visible,
            width: _vm.dialogAfterSale.width,
            "before-close": _vm.handleshouhouClose,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialogAfterSale, "visible", $event)
            },
          },
        },
        [
          _vm.dialogAfterSale.type == "afterSale"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "deletegroup_title",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("span", { staticClass: "deletegroup_title_item" }, [
                      _vm._v("售后"),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticStyle: { "margin-bottom": "20px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.applyDialog },
                      },
                      [_vm._v("申请售后")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.goodsListDialog,
                      "header-cell-style": {
                        background: "#fafafa",
                        color: "#333333",
                      },
                    },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { width: "50" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-radio",
                                  {
                                    staticStyle: { color: "#fff" },
                                    attrs: { label: scope.$index },
                                    nativeOn: {
                                      change: function ($event) {
                                        return _vm.getCurrentRow(scope.row)
                                      },
                                    },
                                    model: {
                                      value: _vm.multipleSelection,
                                      callback: function ($$v) {
                                        _vm.multipleSelection = $$v
                                      },
                                      expression: "multipleSelection",
                                    },
                                  },
                                  [_c("span", [_vm._v(" ")])]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        47093805
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "updatedTime",
                        label: "商品信息",
                        headerAlign: "left",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "left" } },
                                  [
                                    _c("div", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            props.row.goodsName
                                              ? props.row.goodsName
                                              : "-"
                                          )
                                        ),
                                      ]),
                                      props.row.goodsType == "3"
                                        ? _c("span", { staticClass: "gift" }, [
                                            _vm._v("赠品"),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            props.row.goodsSkuName
                                              ? props.row.goodsSkuName
                                              : "-"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v(
                                        " 商品编码：" +
                                          _vm._s(
                                            props.row.goodsNo
                                              ? props.row.goodsNo
                                              : "-"
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1237664513
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "authListStr",
                        label: "单价/数量",
                        "header-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "￥" + _vm._s(props.row.unitPrice)
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v("x" + _vm._s(props.row.quantity)),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1824988655
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "authListStr",
                        label: "小计",
                        "header-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "实付￥" + _vm._s(props.row.amountPaid)
                                      ),
                                    ]),
                                    _c("p", [
                                      _vm._v("￥" + _vm._s(props.row.subtotal)),
                                    ]),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2425156658
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "authListStr",
                        label: "其他信息",
                        "header-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    props.row.subsetStatus != "售后关闭" &&
                                    props.row.status != 0
                                      ? _c("p", [
                                          _vm._v(
                                            " " +
                                              _vm._s(props.row.statusCn) +
                                              ":￥" +
                                              _vm._s(props.row.refundMoney) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    props.row.subsetStatus
                                      ? _c("p", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                props.row.subsetStatus ==
                                                  "无售后"
                                                  ? "-"
                                                  : props.row.subsetStatus
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                    props.row.subsetStatus != "售后关闭" &&
                                    props.row.afterSaleReason
                                      ? _c("p", [
                                          _vm._v(
                                            " 售后原因:" +
                                              _vm._s(
                                                props.row.afterSaleReason
                                                  ? props.row.afterSaleReason
                                                  : "-"
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4145865110
                      ),
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialogAfterSale.type == "applyAfterSale"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "deletegroup_title",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("span", { staticClass: "deletegroup_title_item" }, [
                      _vm._v("售后"),
                    ]),
                  ]
                ),
                _c(
                  "el-form",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: { model: _vm.ruleForm, rules: _vm.rulesRuleForm },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "退款类型", prop: "afterType" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.ruleForm.afterType,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "afterType", $$v)
                              },
                              expression: "ruleForm.afterType",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.after_type,
                            function (item, index) {
                              return _c(
                                "el-radio",
                                { key: index, attrs: { label: item.dictId } },
                                [_vm._v(_vm._s(item.dictName))]
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "售后原因", prop: "afterSaleReason" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择活动区域" },
                            model: {
                              value: _vm.ruleForm.afterSaleReason,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "afterSaleReason", $$v)
                              },
                              expression: "ruleForm.afterSaleReason",
                            },
                          },
                          _vm._l(
                            _vm.dictionaries.after_sale_reason,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.dictName,
                                  value: item.dictId,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "290px" },
                        attrs: { prop: "refundMoney", "label-width": "100px" },
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _vm._v(" 退款金额（最多"),
                            _c("span", { staticStyle: { color: "red" } }, [
                              _vm._v(_vm._s(_vm.afterMoney)),
                            ]),
                            _vm._v("元） "),
                          ]
                        ),
                        _c("el-input", {
                          attrs: { placeholder: "请输入退款金额" },
                          on: {
                            input: (v) =>
                              (_vm.ruleForm.refundMoney = v.replace(
                                /^(\d*\.?\d{0,2}).*/,
                                "$1"
                              )),
                          },
                          model: {
                            value: _vm.ruleForm.refundMoney,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "refundMoney", $$v)
                            },
                            expression: "ruleForm.refundMoney",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "退款说明（选填）",
                          prop: "refundExplain",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入退款说明",
                            maxlength: "200",
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.ruleForm.refundExplain,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "refundExplain", $$v)
                            },
                            expression: "ruleForm.refundExplain",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "上传凭证（选填）最多3张",
                          prop: "appendixList",
                        },
                      },
                      [
                        _c("upload-picture", {
                          attrs: {
                            limit: 3,
                            "file-list": _vm.ruleForm.appendixList,
                          },
                          on: {
                            getUrl: _vm.getUrl,
                            handleRemove: _vm.handleRemove,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.handledeleteClose },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary", loading: _vm.loading },
                        on: {
                          click: function ($event) {
                            return _vm.submitAfterSale("ruleForm")
                          },
                        },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialogAfterSale.type == "record"
            ? [
                _c(
                  "div",
                  {
                    staticClass: "deletegroup_title",
                    attrs: { slot: "title" },
                    slot: "title",
                  },
                  [
                    _c("span", { staticClass: "deletegroup_title_item" }, [
                      _vm._v(_vm._s(_vm.dialogAfterSale.title)),
                    ]),
                  ]
                ),
                _c("lb-table", {
                  attrs: {
                    column: _vm.columnRecord,
                    data: _vm.transactionRecord,
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "contentDetails" }, [
      _c("div", { staticClass: "titleBtn" }, [
        _c("div", { staticClass: "title titleblue" }, [_vm._v("订单详情")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _c("img", {
          staticStyle: { "margin-right": "8px" },
          attrs: { src: require("../../assets/icon_guanbi.png") },
        }),
        _c("span", { staticClass: "boldSize" }, [_vm._v(" 审核不通过 ")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticStyle: { display: "flex", "align-items": "center" } },
      [
        _c("img", {
          staticStyle: { "margin-right": "8px" },
          attrs: { src: require("../../assets/icon_guanbi.png") },
        }),
        _c("span", { staticClass: "boldSize" }, [_vm._v(" 订单已关闭 ")]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "about-item-box about-item-title-box" }, [
      _c("div", { staticClass: "about-item about-title" }, [
        _vm._v("订单总金额"),
      ]),
      _c("div", { staticClass: "about-item about-title" }, [
        _vm._v("在线支付金额"),
      ]),
      _c("div", { staticClass: "about-item about-title" }, [
        _vm._v("余额支付金额"),
      ]),
      _c("div", { staticClass: "about-item about-title" }, [_vm._v("优惠券")]),
      _c("div", { staticClass: "about-item about-title" }, [
        _vm._v("使用积分"),
      ]),
      _c("div", { staticClass: "about-item about-title" }, [_vm._v("运费")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }